import React from "react";

export default function HorizontalCardLoader({ dark = false, layout = "grid" }) {
  const bgClass = dark ? "bg-zinc-900/60 border-zinc-800/80 shadow-zinc-950/40" : "bg-white border-gray-100 shadow-gray-200/50";
  const placeholderClass = dark ? "bg-zinc-800/60" : "bg-gray-200";

  if (layout === "list") {
    return (
      <>
        <div className={`w-full flex items-center justify-between p-2.5 sm:p-3 rounded-2xl border ${bgClass} gap-3 my-1`}>
          {/* Thumbnail Skeleton */}
          <div
            data-placeholder=""
            className={`w-14 h-14 sm:w-16 sm:h-16 rounded-xl overflow-hidden relative flex-shrink-0 ${placeholderClass}`}
          />
          {/* Details Skeleton */}
          <div className="flex-1 flex flex-col gap-2 min-w-0">
            <div
              data-placeholder=""
              className={`h-4 w-3/4 rounded-md overflow-hidden relative ${placeholderClass}`}
            />
            <div
              data-placeholder=""
              className={`h-3 w-1/2 rounded-md overflow-hidden relative ${placeholderClass}`}
            />
            <div
              data-placeholder=""
              className={`h-2.5 w-1/3 rounded-md overflow-hidden relative ${placeholderClass}`}
            />
          </div>
          {/* Action Skeleton */}
          <div className="flex flex-col items-end gap-2 flex-shrink-0">
            <div
              data-placeholder=""
              className={`h-3.5 w-12 rounded-md overflow-hidden relative ${placeholderClass}`}
            />
            <div
              data-placeholder=""
              className={`w-8 h-8 rounded-full overflow-hidden relative ${placeholderClass}`}
            />
          </div>
        </div>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              [data-placeholder]::after {
                content: " ";
                box-shadow: 0 0 50px 12px ${dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.8)"};
                position: absolute;
                top: 0;
                left: -100%;
                height: 100%;
                width: 50%;
                animation: load 1.2s infinite;
              }
              @keyframes load {
                0% { left: -100% }
                100% { left: 150% }
              }
            `,
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className="w-full flex items-center flex-col py-1">
        <div className={`flex flex-col w-full max-w-full sm:max-w-[13rem] xl:max-w-[14rem] shadow-md rounded-2xl border items-center overflow-hidden ${bgClass}`}>
          {/* Card Image Skeleton */}
          <div
            data-placeholder=""
            className={`h-[9.5rem] sm:h-[12.5rem] xl:h-[13.5rem] w-full overflow-hidden relative ${placeholderClass}`}
          />
          {/* Content Rows */}
          <div className="flex flex-col p-2.5 sm:p-3 w-full gap-2">
            <div className="flex items-center gap-1.5 w-full">
              <div
                data-placeholder=""
                className={`h-4 w-3/4 rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>
            <div className="flex items-center gap-1.5 w-full">
              <div
                data-placeholder=""
                className={`h-3 w-1/2 rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>

            {/* Bottom Actions Skeleton Row */}
            <div className="flex justify-between items-center mt-2 pt-2 border-t border-zinc-800/40 w-full gap-2">
              <div
                data-placeholder=""
                className={`h-3.5 w-1/3 rounded overflow-hidden relative ${placeholderClass}`}
              />
              <div
                data-placeholder=""
                className={`h-3.5 w-1/3 rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>
          </div>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            [data-placeholder]::after {
              content: " ";
              box-shadow: 0 0 50px 12px ${dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.8)"};
              position: absolute;
              top: 0;
              left: -100%;
              height: 100%;
              width: 50%;
              animation: load 1.2s infinite;
            }
            @keyframes load {
              0% { left: -100% }
              100% { left: 150% }
            }
          `,
        }}
      />
    </>
  );
}

